export const modes = {
    EDIT: 'edit',
    READONLY: 'readonly',
    EDIT_PERMISSION: 'edit_perm',
    READONLY_PERMISSION: 'readonly_perm',
}